export default {
    isLoggedIn: () => {
        return window.localStorage.getItem('token') !== null;
    },
    allPages: state => {
        let staticPages = [];
        
        for (let menuItem of state.menuItems) {
            staticPages.push(...menuItem.children);
        }

        return staticPages;
    },
    staticPages: (_, getters) => {
        return getters.allPages.filter(m => m.type === 'static');
    },
    currentMenuItem: (state, getters) => {
        if (!state.currentRoute) {
            return null;
        }

        if (state.currentRoute.params && state.currentRoute.params.type) {
            let match = getters.staticPages.find(s => s.slug === state.currentRoute.params.type);
            if (match) {
                return match;
            }
        }

        let match = getters.allPages.find(c => {
            let routeNameMatches = `${c.route_name}-${state.language}` === state.currentRoute.name || `${c.route_name}-Paginated-${state.language}` === state.currentRoute.name;
            if (routeNameMatches) {
                if (!state.currentRoute.params) {
                    return true;
                }

                for (let key in state.currentRoute.params) {
                    if (key.includes('_') && c.route_params[key.split('_')[0]]) {
                        continue;
                    }

                    if (c.route_params[`${key}_${state.language}`] !== state.currentRoute.params[key]) {
                        return false;
                    }
                }

                return true;
            }
        });

        return match;
    },
    currentPageType: (state, getters) => {
        if (!state.currentRoute || !state.currentRoute.params || !state.currentRoute.params.type) {
            return null;
        }

        let page = getters.allPages.find(s => s.slug === state.currentRoute.params.type || (s.route_params && s.route_params.type === state.currentRoute.params.type));
        return page ? page.slug_en || page.route_params.type_en : null;
    },
    localizedPageType: (_, getters) => {
        if (!getters.currentPageType) {
            return null;
        }

        let page = getters.allPages.find(s => s.slug_en == getters.currentPageType || (s.route_params && s.route_params.type_en == getters.currentPageType));
        return page ? page.slug || page.route_params.type : null;
    },
    currentPageTitle: (state, getters) => {
        if (!state.currentRoute || !state.currentRoute.params || !state.currentRoute.params.type) {
            return null;
        }

        if (getters.currentMenuItem) {
            return getters.currentMenuItem.name;
        }

        return null;
    }
};



// WEBPACK FOOTER //
// ./src/store/bmr/getters.js